import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../core';
import { HttpClient } from '@angular/common/http';
import { BaseStore, RegistrationModel, ProspectBase, SessionItem, eItem, Product, ProspectInfo, Stage, ProspectStage, Cycle, ProspectCycle, StagePrice, WSAppSource, WSUserRole, WSRegMode, ProductPrice } from '../../shared';
import * as $ from 'jquery';
import { OptionalForm, EndWithSlash } from 'projects/lib-components/src/public_api';
import { forkJoin, Observable } from 'rxjs';

@Component({
  selector: 'webstore-formulaire',
  templateUrl: './formulaire.component.html',
  styleUrls: ['./formulaire.component.css']
})

export class FormulaireComponent extends BaseStore implements OnInit {
  //step1: EtapeItem = new EtapeItem();
  //step2: EtapeItem = new EtapeItem();
  //step3: EtapeItem = new EtapeItem();
  //step4: EtapeItem = new EtapeItem();
  //step5: EtapeItem = new EtapeItem();
  //step6: EtapeItem = new EtapeItem();

  title: string = '';
  subtitle: string = '';
  registrationData: RegistrationModel;
  prospect: ProspectBase = new ProspectBase();
  textValue: string = '';
  textValueBis: string = '';
  msgValidate: string = '';
  listPrices: StagePrice[] = [];
  selectedPrice: string = '0';
  optionalFieldsCPPT: OptionalForm[] = [];
  optionalFieldsCNT: OptionalForm[] = [];

  constructor(
    public store: StoreService,
    private http: HttpClient
  ) { super(store); }

  ngOnInit(): void {
    this.initData();
  }

  sendData(): void {
    const valid: string = this.Validate();
    if (valid !== '') {
      this.store.showAlert(valid);
      return;
    }

    //#region multi price management
    if (this.listPrices.length > 1) {
      if (this.selectedPrice === '0') {
        this.store.showAlert(`Vous devez choisir un prix`);
        return;
      }
      switch (this.registrationData.RegistrationMode) {
        case WSRegMode.INFO:
          const pp: ProductPrice[] = this.listPrices.filter((e: ProductPrice): boolean => e.Order === this.selectedPrice);
          if (pp.length === 0) {
            this.store.showAlert(`un problème est survenu dans le choix d'un prix`);
            return;
          }
          this.registrationData.ProspectData.Prix_Product = pp[0];
          break;
        case WSRegMode.PREINSCRIPTION:
          const sp: StagePrice[] = this.listPrices.filter((e: StagePrice): boolean => e.Order === this.selectedPrice);
          if (sp.length === 0) {
            this.store.showAlert(`un problème est survenu dans le choix d'un prix`);
            return;
          }
          this.registrationData.InscriptionData.Prix_Stage = sp[0];
        break;
      }
      
    }
    //#endregion

    //#region optional fields management

    this.registrationData.OptionalFieldsCPPT = this.optionalFieldsCPPT;
    this.registrationData.OptionalFieldsCNT = this.optionalFieldsCNT;

    //#endregion

    this.registrationData.SenderRole = WSUserRole.NONE; // 'SENDER';

    this.store.showSplash(true);
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/registration/V2/`;
    this.http.post<RegistrationModel>(destUrl, this.registrationData).subscribe((data: RegistrationModel): void => {
      this.store.showSplash(false);
      this.store.warning(data.Error !== '' ? data.Error : data.SuccessMessage);

      // TRACE ERROR (do not remove this line)
      if (data.HasError)
        this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data.Error}`);
      // TRACE ERROR (do not remove this line)
      if (data.Alert && data.Alert !== '')
        this.store.traceData(`--FORMULAIRE ALERT: \r\n ${data.Alert}`);
    }, (error: any): void => {
      console.error(JSON.stringify(error));
    });
    if (this.store.configModel.ConfirmRegistrationByMail) {
      this.store.showSplash(false);
      if ($('#modalMxg').length > 0) {
        $('#modalMxg').css('display', 'block');
      }
    }
  }
  //sendData2(): void {
  //  const valid: string = this.Validate();
  //  if (valid !== '') {
  //    this.store.showAlert(valid);
  //    return;
  //  }

  //  //#region multi price management
  //  if (this.listPrices.length > 1) {
  //    if (this.selectedPrice === '0') {
  //      this.store.showAlert(`Vous devez choisir un prix`);
  //      return;
  //    }

  //    const sp: StagePrice[] = this.listPrices.filter((e: StagePrice): boolean => e.Order === this.selectedPrice);
  //    if (sp.length === 0) {
  //      this.store.showAlert(`un problème est survenu dans le choix d'un prix`);
  //      return;
  //    }
  //    this.registrationData.InscriptionData.Prix_Stage = sp[0];
  //  }
  //  //#endregion

  //  //#region optional fields management

  //  this.registrationData.OptionalFieldsCPPT = this.optionalFieldsCPPT;
  //  this.registrationData.OptionalFieldsCNT = this.optionalFieldsCNT;

  //  //#endregion

  //  const model1: RegistrationModel = this.registrationData;
  //  model1.SenderRole = WSUserRole.NONE; // 'SENDER';
  //  model1.Action = 'STEP1'; // set processData and get administrators list
  //  this.step1.show = true;
  //  const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/registrationstep/v1/`;
  //  this.http.post<RegistrationModel>(destUrl, model1).subscribe((data1: RegistrationModel): void => {
  //    if (data1.HasError) {
  //      this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data1.Error}`);
  //      this.step1.result = 'ERR';
  //      this.step1.message = data1.Error;
  //      return;
  //    }
  //    this.step1.message = data1.ResponseSteps.MsgStep;
  //    this.step1.result = 'OK';

  //    const model2: RegistrationModel = data1;
  //    console.log(data1.ResponseSteps.ProcessDataObject);
  //    console.log(model2.ResponseSteps.ProcessDataObject);
  //    model2.Action = 'STEP2'; // set prospect and contact subjects
  //    this.step2.show = true;
  //    this.http.post<RegistrationModel>(destUrl, model2).subscribe((data2: RegistrationModel): void => {
  //      if (data2.HasError) {
  //        this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data2.Error}`);
  //        this.step2.result = 'ERR';
  //        this.step2.message = data2.Error;
  //        return;
  //      }
  //      this.step2.message = data2.ResponseSteps.MsgStep;
  //      this.step2.result = 'OK';

  //      const model3: RegistrationModel = data2;
  //      console.log(data2.ResponseSteps.ProcessDataObject);
  //      console.log(model3.ResponseSteps.ProcessDataObject);
  //      model3.Action = 'STEP3'; // set project context
  //      this.step3.show = true;
  //      this.http.post<RegistrationModel>(destUrl, model3).subscribe((data3: RegistrationModel): void => {
  //        if (data3.HasError) {
  //          this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data3.Error}`);
  //          this.step3.result = 'ERR';
  //          this.step3.message = data3.Error;
  //        }
  //        this.step3.message = data3.ResponseSteps.MsgStep;
  //        this.step3.result = 'OK';

  //        const model4: RegistrationModel = data3;
  //        model4.Action = 'STEP4'; // set devis context
  //        this.step4.show = true;
  //        const step4R: Observable<RegistrationModel> = this.http.post<RegistrationModel>(destUrl, model4);

  //        const model5: RegistrationModel = data3;
  //        model5.Action = 'STEP5'; // set action co context
  //        this.step5.show = true;
  //        const step5R: Observable<RegistrationModel> = this.http.post<RegistrationModel>(destUrl, model5);

  //        forkJoin([step4R, step5R]).subscribe((response: [RegistrationModel, RegistrationModel]) => {
  //          const devis: RegistrationModel = response[0];
  //          const actionco: RegistrationModel = response[1];

  //          if (devis.HasError) {
  //            this.store.traceData(`--FORMULAIRE ERROR: \r\n ${devis.Error}`);
  //            this.step4.result = 'ERR';
  //            this.step4.message = devis.Error;
  //          }
  //          this.step4.message = devis.ResponseSteps.MsgStep;
  //          this.step4.result = 'OK';

  //          if (actionco.HasError) {
  //            this.store.traceData(`--FORMULAIRE ERROR: \r\n ${actionco.Error}`);
  //            this.step5.result = 'ERR';
  //            this.step5.message = actionco.Error;
  //          }
  //          this.step5.message = actionco.ResponseSteps.MsgStep;
  //          this.step5.result = 'OK';

  //          //#region STEP6
  //          devis.ResponseSteps.LogsList.push(actionco.ResponseSteps.LogsList[actionco.ResponseSteps.LogsList.length - 1]);
  //          const model6: RegistrationModel = devis;
  //          model6.Action = 'STEP6'; // set action co context
  //          this.step6.show = true;
  //          this.http.post<RegistrationModel>(destUrl, model6).subscribe((data6: RegistrationModel): void => {
  //            if (data6.HasError) {
  //              this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data6.Error}`);
  //              this.step6.result = 'ERR';
  //            }
  //            console.log(data6.Alert);
  //            this.step6.message = data6.ResponseSteps.MsgStep;
  //            this.step6.result = 'OK';
  //          });
  //          //#endregion
  //        });

  //      });

  //    });
  //  });

  //  if (this.store.configModel.ConfirmRegistrationByMail) {
  //    this.store.showSplash(false);
  //    if ($('#modalMxg').length > 0) {
  //      $('#modalMxg').css('display', 'block');
  //    }
  //  }
  //}

  closeMsg(): void {
    //////if (window.opener) {
    //////  //alert('inside a pop-up window or target=_blank window');
    //////  self.close();
    //////} else if (window.top !== window.self) {
    //////  //alert('inside an iframe');
    //////  this.store.openPage('HME');
    //////} else {
    //////  //alert('this is a top level window');
    this.store.openPage('HME');
    //////}
  }
  //closeRegistration(): void {
  //  this.step1 = new EtapeItem();
  //  this.step2 = new EtapeItem();
  //  this.step3 = new EtapeItem();
  //  this.step4 = new EtapeItem();
  //  this.step5 = new EtapeItem();
  //  this.step6 = new EtapeItem();
  //}

  //// https://codepen.io/cassidoo/pen/wEXQaG
  //let steps = [];
  //progress(elementId: string): void {
  //  // the id of the element is the number of the step : 1, 2, 3, 4, ...
  //  let p = elementId * 30;
  //  document.getElementsByClassName('percent')[0].style.width = `${p}%`;
  //  steps.forEach((e) => {
  //    if (e.id === stepNum) {
  //      e.classList.add('selected');
  //      e.classList.remove('completed');
  //    }
  //    if (e.id < stepNum) {
  //      e.classList.add('completed');
  //    }
  //    if (e.id > stepNum) {
  //      e.classList.remove('selected', 'completed');
  //    }
  //  });
  //}

  private initData(): void {
    this.store.showSplash(true);
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/registration/V2/INITOPTIONAL/0`;
    this.result = this.http.get<RegistrationModel>(destUrl).subscribe((data: RegistrationModel) => {
      if (!data.HasError) {
        this.optionalFieldsCPPT = data.OptionalFieldsCPPT;
        this.optionalFieldsCNT = data.OptionalFieldsCNT;

        this.registrationData = data;
        this.registrationData.RegistrationMode = this.store.AppSettings.RegistrationMode;
        this.registrationData.Source = WSAppSource.PUBLIC;  //'MIXED';
        switch (this.registrationData.RegistrationMode) {
          case WSRegMode.INFO:
            const pd: SessionItem | null = super.getSession(eItem.PRODUCT);
            if (pd) {
              this.initInfo(pd);
            }
            break;
          case WSRegMode.PREINSCRIPTION:
            const sd: SessionItem | null = super.getSession(eItem.STAGE);
            if (sd) {
              this.initPreinscription(sd);
            }
            break;
          case WSRegMode.PREINSCRIPTION_CYCLE:
            const cd: SessionItem | null = super.getSession(eItem.CYCLE);
            if (cd) {
              this.initPreinscriptionCycles(cd);
            }
            break;
        }
      }
      this.store.showSplash(false);
    });
  }

  private initInfo(pd: SessionItem): void {
    const p: Product = JSON.parse(pd.jsData);
    this.registrationData.ProductData = p;
    this.registrationData.ProspectData = new ProspectInfo();
    this.registrationData.ProspectData.UserRole = this.store.AppSettings.WebStoreUserRole;
    this.registrationData.ProspectData.ProduitId = p.Ident;
    this.registrationData.ProspectData.NomProduit = p.DesigPRO;
    this.registrationData.ProspectData.CodeProduit = p.Code_PRO;
    if (p.Responsable && p.Responsable.Ident !== '0')
      this.registrationData.ProspectData.ResponsablesList.push(p.Responsable);
    else {
      // TRACE ERROR (do not remove this line)
      this.store.traceData(`--PRODUCT IDENT ${p.Ident} '${p.DesigPRO}' HAS NOT A SPECIFIED RESPONSABLE`);
    }

    //#region multi price management
    this.listPrices = p.PricesList;
    if (this.listPrices.length > 0) {
      if (this.listPrices.length === 1) {
        this.listPrices[0].Selected = true;
        this.registrationData.ProspectData.Prix_Product = this.listPrices[0]
      }
      else {
        const pl: StagePrice[] = this.listPrices.filter((p: StagePrice): boolean => p.Selected);
        this.listPrices = pl;
        if (this.listPrices.length === 0) {
          this.registrationData.ProspectData.Prix_Product = this.listPrices[0];
        }
      }
    }
    else {
      this.registrationData.ProspectData.Prix_Product = new ProductPrice();
      this.registrationData.ProspectData.Prix_Product.Label = 'Tarif';
      this.registrationData.ProspectData.Prix_Product.Order = '1';
      this.registrationData.ProspectData.Prix_Product.Selected = true;
      this.registrationData.ProspectData.Prix_Product.Tooltip = '';
      this.registrationData.ProspectData.Prix_Product.Value = '0,00 €'
    }
    //#endregion

    this.title = super.trad('inforequest');
    this.subtitle = `${p.DesigPRO} (ref: ${p.Code_PRO})`;
    this.prospect = this.registrationData.ProspectData as ProspectBase;
  }

  private initPreinscription(sd: SessionItem): void {
    const s: Stage = JSON.parse(sd.jsData);
    this.registrationData.StageData = s;
    this.registrationData.InscriptionData = new ProspectStage();
    this.registrationData.InscriptionData.UserRole = this.store.AppSettings.WebStoreUserRole;
    this.registrationData.InscriptionData.IdentStage = s.Ident;
    this.registrationData.InscriptionData.StageName = s.Info_PRO;
    this.registrationData.InscriptionData.NumStage = s.NumstPRO;

    //#region multi price management
    this.listPrices = s.PricesList;
    if (this.listPrices.length > 0) {
      if (this.listPrices.length === 1) {
        this.listPrices[0].Selected = true;
        this.registrationData.InscriptionData.Prix_Stage = this.listPrices[0]
      }
      else {
        const pl: StagePrice[] = this.listPrices.filter((p: StagePrice): boolean => p.Selected);
        this.listPrices = pl;
        if (this.listPrices.length === 0) {
          this.registrationData.InscriptionData.Prix_Stage = this.listPrices[0];
        }
      }
    }
    else {
      this.registrationData.InscriptionData.Prix_Stage = new StagePrice();
      this.registrationData.InscriptionData.Prix_Stage.Label = 'Tarif';
      this.registrationData.InscriptionData.Prix_Stage.Order = '1';
      this.registrationData.InscriptionData.Prix_Stage.Selected = true;
      this.registrationData.InscriptionData.Prix_Stage.Tooltip = '';
      this.registrationData.InscriptionData.Prix_Stage.Value = '0,00 €'
    }
    //#endregion

    if (s.ResponsablesList && s.ResponsablesList.length > 0)
      this.registrationData.InscriptionData.ResponsablesList = s.ResponsablesList;
    else {
      // TRACE ERROR (do not remove this line)
      this.store.traceData(`--STAGE IDENT ${s.Ident} '${s.Info_PRO}' HAS NOT A SPECIFIED RESPONSABLE`);
    }

    this.title = 'Pré-inscription';
    this.subtitle = s.Info_PRO;
    this.prospect = this.registrationData.InscriptionData as ProspectBase;

  }

  private initPreinscriptionCycles(cd: SessionItem): void {
    const c: Cycle = JSON.parse(cd.jsData);
    this.registrationData.CycleData = c;
    this.registrationData.InscriptionCycleData = new ProspectCycle();
    this.registrationData.InscriptionCycleData.UserRole = this.store.AppSettings.WebStoreUserRole;
    this.registrationData.InscriptionCycleData.IdentCycle = c.Ident;
    this.registrationData.InscriptionCycleData.CycleName = c.ValueDOS;
    this.registrationData.InscriptionCycleData.ListStage = c.StageCycle;
    this.registrationData.InscriptionCycleData.Prix_Cycle = c.PriCyDOS;
    if (c.ResponsableCycle && c.ResponsableCycle.Ident !== '0') {
      this.registrationData.InscriptionCycleData.ResponsablesList.push(c.ResponsableCycle);
    }
    else {
      // TRACE ERROR (do not remove this line)
      this.store.traceData(`--CYCLE IDENT ${c.Ident} '${c.ValueDOS}' HAS NOT A SPECIFIED RESPONSABLE`);
    }

    this.title = 'Pré-inscription';
    this.subtitle = c.ValueDOS;
    this.prospect = this.registrationData.InscriptionCycleData as ProspectBase;
  }

  private Validate(): string {
    let msg: string = '';
    const txt: string = this.store.getTrad('msgFormulaire8');
    const grpList: JQuery<HTMLElement> = $('.group-mt');
    if (grpList.length > 0) {
      $('.group-mt').each(function (): void {
        const lab: JQuery<HTMLElement> = $(this).find('label');
        if (lab.length > 0) {
          const req: JQuery<HTMLElement> = $(lab).find('span[class="required"]');
          if (req.length > 0) {
            const inp: JQuery<HTMLElement> = $(this).find('input');
            if (inp.length > 0) {
              if ($(inp).val() === '') {
                msg += `${txt.replace('{0}', lab.text().substr(0, lab.text().length - 1))} \n`;
              }
            }
          }
        }
      });
    }
    return msg;
  }
}

//export class EtapeItem {
//  show: boolean;
//  message: string;
//  result: string;
//  constructor() {
//    this.show = false;
//    this.message = '';
//    this.result = 'WAIT';
//  }
//}
